<script lang="ts">
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import {ItemPrice} from "../../../interfaces/item-price.class";
    import SimpleTablePrices from "./SimpleTablePrices.svelte";
    import type {IModalSendPrices} from "../modals/modal.interface";

    export let open = false;
    export let action: string;
    export let hasAlert: boolean;
    export let alert: Array<ItemPrice>;
    export let incomplete: Array<ItemPrice>;
    export let complete: Array<ItemPrice>;
    let okLabel: string = 'ACEPTAR';
    let cancelLabel: string = 'VOLVER';
    export let onAccept = () => {
    };
    export let onCancel = () => {
    };
    const onOk = () => {
        onAccept();
        close();
    }
    const onClose = () => {
        onCancel();
        close();
    }

    export function show() {
        open = true;
    }

    export function setPrices(params: IModalSendPrices) {
        hasAlert = params.hasAlert;
        alert = params.alert;
        incomplete = params.incomplete;
        complete = params.complete;
        onAccept = params.onAccept;
        onCancel = params.onCancel;
        action = params.action;
        if (action != "Guardar")
            okLabel = hasAlert ? 'ENVIAR A REVISIÓN' : 'ENVIAR';
    }

    function close() {
        open = false;
        setDefault();
    }

    function setDefault() {
        hasAlert = false;
        alert = [];
        incomplete = [];
        complete = [];
        okLabel = 'ACEPTAR'
        onAccept = () => {
        };
        onCancel = () => {
        };
    }

</script>
<div class="clipboard-background" class:active={open}>
    <div class="clipboard-content">
        <div class="overflow-y-scroll">
            {#if hasAlert}
                <h2 class="mb-1">
                    <i class="far fa-exclamation-triangle"></i>
                    ATENCIÓN
                </h2>

                <div class="w-100">
                    <SimpleTablePrices title="Items que seran enviados a revisión"
                                       prices={alert}/>
                </div>
            {/if}
            {#if complete?.length > 0}
                <div class="w-100">
                    <SimpleTablePrices title="Items completos que seran guardados"
                                       prices={complete}/>
                </div>
            {/if}
            {#if incomplete?.length > 0}
                <div class="w-100">
                    <SimpleTablePrices title="Items incompletos"
                                       prices={incomplete}/>
                </div>
            {/if}
            {#if hasAlert}
                <div class="box-l sx-ii alert-ga shadow radius mb-1">
                    Existen precios dentro de la propuesta que se encuentran por debajo del mínimo aprobado por
                    la
                    división,
                    o
                    por debajo del costo. Esta propuesta será enviada a revisión por parte del gerente de
                    división o
                    gerente
                    general, según corresponda.
                </div>
            {/if}
        </div>
        <div class="box-r sx-ii">
            <NauiButton caption={okLabel}
                        color="accent"
                        mode="solid"
                        on:click={onOk}/>
            <NauiButton caption={cancelLabel}
                        color="accent"
                        mode="outline"
                        on:click={onClose}/>
        </div>
    </div>
</div>

<style>
    h2, h2 i {
        color: var(--primary)
    }

    .alert-ga {
        background-color: #FAFAFA;
        color: #04AA7C;
        padding: .75rem 1rem;
    }

    .alert-ga > * {
        color: #04AA7C;
    }

    .clipboard-background {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(54, 54, 54, .45);
        z-index: 30;
        opacity: 0;
        transform: translateX(100%);
        transition: 0.2s ease-in-out all;
    }

    .clipboard-background.active {
        transform: translateX(0%);
        opacity: 1;
    }

    .clipboard-content {
        position: relative;
        background-color: white;
        width: calc(100% - 4rem);
        height: calc(100% - 4rem);
        border-radius: 10px;
        margin-top: 2rem;
        margin-left: 2rem;
        z-index: 40;
        padding: 2rem 2rem;
        display: grid;
        grid-template-rows: 1fr 50px;
    }
</style>